import { z } from 'zod';
import type { IscEnrollmentStatusDto } from './iscEnrollmentStatus.dto';

/**
 * Request body for on-demand Avon clinical form sync + enrollment projection update.
 */
export const SyncAvonClinicalFormsRequestSchema = z
  .object({
    memberIds: z.array(z.string().uuid()).min(1),
  })
  .strict();

/** Inferred sync-request type. */
export type SyncAvonClinicalFormsRequestDto = z.infer<
  typeof SyncAvonClinicalFormsRequestSchema
>;

/**
 * Response after syncing clinical forms and refreshing enrollment projection.
 * Partial Avon failures are reported in-band via `failedMemberIds` (HTTP 200);
 * clients should not expect a 5xx solely because some members failed.
 * `enrollmentStatuses` is aligned with `memberIds`; entries are `null` when the
 * member is missing or soft-deleted (status cannot be loaded).
 */
export type SyncAvonClinicalFormsResponseDto = {
  memberIds: string[];
  syncedMemberIds: string[];
  failedMemberIds: string[];
  enrollmentStatuses: Array<IscEnrollmentStatusDto | null>;
};
